import { useTranslation } from 'react-i18next';

export default function HowItWorksSection() {
  const { t } = useTranslation();

  const steps = [
    { icon: 'ri-list-check', text: t('step1') },
    { icon: 'ri-search-line', text: t('step2') },
    { icon: 'ri-bar-chart-grouped-line', text: t('step3') },
    { icon: 'ri-camera-line', text: t('step4') },
    { icon: 'ri-book-read-line', text: t('step5') },
    { icon: 'ri-external-link-line', text: t('step6') },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 text-center mb-12">
          {t('howItWorksH2')}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500 text-white text-xl font-heading shadow-lg shadow-primary-500/20">
                {index + 1}
              </div>
              <div className="w-8 h-8 mx-auto mb-2 flex items-center justify-center">
                <i className={`${step.icon} text-primary-600 text-lg`} style={{ width: 20, height: 20 }} />
              </div>
              <p className="text-sm text-foreground-700 leading-snug">
                {step.text}
              </p>
            </div>
          ))}
        </div>
        <p className="text-center text-sm text-foreground-500 mt-10 max-w-2xl mx-auto">
          {t('howItWorksNote')}
        </p>
      </div>
    </section>
  );
}